import type { FC } from 'react';
import type { PreDrillSuggestionCandidate } from 'types/api-responses';
import { pctScore } from './utils';
import { TargetZoneTile, zoneMetricFields } from './target-zone-tile';

interface TargetZoneSuggestionTileProps {
  candidate: PreDrillSuggestionCandidate;
  index: number;
}

// AI-ranked candidate card. A thin adapter over the shared TargetZoneTile: the
// top-ranked tile carries the "Recommended" tag, and the breakdown always shows.
export const TargetZoneSuggestionTile: FC<TargetZoneSuggestionTileProps> = ({
  candidate,
  index,
}) => (
  <TargetZoneTile
    eyebrow={`AI Suggestion ${index + 1}`}
    tag={index === 0 ? { label: 'Recommended', type: 'cyan' } : undefined}
    name={candidate.geologicIntervalName}
    fields={zoneMetricFields({
      topTvdFt: candidate.depthRange?.topTvdFt,
      bottomTvdFt: candidate.depthRange?.bottomTvdFt,
      thicknessFt: candidate.thicknessFt,
      offsetsInZone: candidate.offsetsInZone,
      nearbyPermitsInZone: candidate.nearbyPermitsInZone,
    })}
    confidence={pctScore(candidate.score)}
    breakdown={candidate.breakdown}
    alwaysShowBreakdown
  />
);
